import EastIcon from '@mui/icons-material/East'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import TallCard from './components/TallCard'
import { useFinance } from '@src/api/finance-api'
import { usePayment } from '@src/api/payment-api/payments-api'
import { useGetActivePersonLoan } from '@src/api/person-api'
import { CustomButton, PageSpinner, TitleSection } from '@src/components'
import { formatDateLanguage,capitalizeFirstLetterOnly } from '@src/services/Formatter'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import ShortCard from './components/ShortCard'
import {
  CardsContainer,
  ContactButton,
  LoanButtons,
  LoanStatusContainer,
  ShortCardsContainer,
} from './components/StyledComponent'
import { Box, Container, Grid } from '@mui/material'

const Loan = () => {
  const { t,  i18n: { resolvedLanguage }} = useTranslation()
  const { id } = useParams()
  const navigate = useNavigate()
  const [activeLoan, activeLoanId, isLoadingPerso] = useGetActivePersonLoan(id)
  const [financingData, isLoading] = useFinance(activeLoanId)
  const [selectedPayment,isLoadingPayment] = usePayment(activeLoanId)
  const { closestPayment } = selectedPayment ?? {}

  if (isLoadingPerso || isLoading || isLoadingPayment) return <PageSpinner isLoading={true} />

  const renderCards = () => {
    if (!activeLoan || !financingData) return null
    
    const secondValue = activeLoan.lateAmountWithInterest > 0 ? closestPayment?.plannedOnDateUTC : financingData.financingMaxDate;

    const explanationKey = activeLoan.lateAmountWithInterest > 0 ?  'loanStatus.explenationDate' : 'loanStatus.explenationDateEnd';
    
    const titleDateKey = activeLoan.lateAmountWithInterest > 0 ? 'loanStatus.estimateddate' :  'loanStatus.estimatedEnddate';

    return (
      <LoanStatusContainer>
        <CardsContainer>
          <TallCard loanDetails={activeLoan} />
          <ShortCardsContainer>
            <ShortCard
              title={capitalizeFirstLetterOnly(t('loanStatus.loanBalance'))}
              icon={<VisibilityOffIcon/>}
              value={`${activeLoan.totalDue}`}
              additionalInfo={t('loanStatus.loanDescription')}
              isMoney={true}
            />
            <ShortCard
              titleDate={capitalizeFirstLetterOnly(t(titleDateKey))}
              title={capitalizeFirstLetterOnly(t('loanStatus.loanActivationDate'))}
              value={financingData.financingStartDate}
              secondValue={secondValue}
              explenationDate={capitalizeFirstLetterOnly(t(explanationKey))}
              formatFunction={(date) => formatDateLanguage(date, resolvedLanguage)}
            />
          </ShortCardsContainer>
        </CardsContainer>
      </LoanStatusContainer>
    )
  }

  const renderButtons = () => {
    if (!activeLoan) return null

    return (
      <>
     {!(activeLoan?.isClosed || activeLoan?.isCodemandeur) && <LoanButtons>
        <CustomButton
        title={t('payment.titleap')}
        onClick={() => navigate(`/add-payment/${activeLoanId}`)}
        Icon={EastIcon}
        /> 
        {activeLoan.lateAmountWithInterest > 0 && activeLoan.frequencyType === 0 &&(
            <CustomButton
              title={t('loanStatus.spreadPayment')}
              onClick={() => navigate(`/delayed-payment/${activeLoanId}/2`)}
              Icon={EastIcon}
            />
        )}
         {activeLoan.lateAmountWithInterest > 0 && activeLoan.frequencyType !== 0 &&(
          <>
            <CustomButton
              title={t('loanStatus.spreadPayment')}
              onClick={() => navigate(`/delayed-payment/${activeLoanId}/2`)}
              Icon={EastIcon}
               />
              <CustomButton
                title={t('loanStatus.spreadPaymentDelay')}
                onClick={() => navigate(`/delayed-payment/${activeLoanId}/3`)}
                Icon={EastIcon}
            />
        </>
          )}
        {activeLoan.lateAmountWithInterest > 0 && (
          <ContactButton>
            {t('loanStatus.сontactme')}
            <EastIcon />
          </ContactButton>
        )}
      </LoanButtons>}
      </>
    )
  }

  return (
    <>
      <TitleSection title={t('loanStatus.myLoan')} />
      <Container component="main" sx={{ flexGrow: 1 }}>
        <Grid container>
          <Grid size={{ xs: 12, md: 9, lg: 10 }}>
            <Box sx={{ padding: { xs: '0 1px', sm: '0 20px' }, boxSizing: 'border-box' }}>
              {renderCards()}
              {renderButtons()}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  )
}

export default Loan
